/* eslint-disable max-len */
import 'react';

const TeamInfoSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = `TeamInfoSvg${Date.now()}`;
    return (<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <defs>
            <linearGradient x1="-16.7204611%" y1="-5.24367785%" x2="100%" y2="59.4828877%" id={`linearGradient-1${id}`}>
                <stop stopColor="#44B1FF" offset="0%"></stop>
                <stop stopColor="#3C76FF" offset="100%"></stop>
            </linearGradient>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="96.8557262%" id={`linearGradient-2${id}`}>
                <stop stopColor="#FFFFFF" offset="0%"></stop>
                <stop stopColor="#D8E5FF" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id={`流程${id}`} stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id={`设计状态描述${id}`} transform="translate(-82.000000, -3916.000000)">
                <g id={`编组-2${id}`} transform="translate(62.000000, 3817.000000)">
                    <g id={`编组-10${id}`} transform="translate(20.000000, 99.000000)">
                        <circle id={`椭圆形${id}`} fill="url(#linearGradient-1)" cx="6" cy="6" r="6"></circle>
                        <path d="M6,5.1 C6.33137085,5.1 6.6,5.36862915 6.6,5.7 L6.6,8.7 C6.6,9.03137085 6.33137085,9.3 6,9.3 C5.66862915,9.3 5.4,9.03137085 5.4,8.7 L5.4,5.7 C5.4,5.36862915 5.66862915,5.1 6,5.1 Z M6.00111136,3 C6.41532493,3 6.75111136,3.33578644 6.75111136,3.75 C6.75111136,4.16421356 6.41532493,4.5 6.00111136,4.5 C5.5868978,4.5 5.25111136,4.16421356 5.25111136,3.75 C5.25111136,3.33578644 5.5868978,3 6.00111136,3 Z" id={`形状结合${id}`} fill={`url(#linearGradient-2${id})`}></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>);
};
export default TeamInfoSvg;
